import React from 'react';
import { Card, CardContent } from './ui/card';
import { whyChooseUs, images } from '../data/mock';
import { Globe, MapPin, Users, Settings } from 'lucide-react';

const iconMap = {
  Globe,
  MapPin,
  Users,
  Settings
};

const WhyChoose = () => {
  return (
    <section id="about" className="py-24 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Grid */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-500">
                  <img
                    src={images.warehouse}
                    alt="Warehouse operations"
                    className="w-full h-48 object-cover"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-500">
                  <img
                    src={images.forklift}
                    alt="Logistics operations"
                    className="w-full h-64 object-cover"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-500">
                  <img
                    src={images.containers}
                    alt="Container operations"
                    className="w-full h-64 object-cover"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-500">
                  <img
                    src={images.plane}
                    alt="Air cargo"
                    className="w-full h-48 object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -z-10 -bottom-10 -left-10 w-64 h-64 bg-amber-500/20 rounded-full blur-3xl" />
          </div>

          {/* Content */}
          <div>
            <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-4">
              Why Choose Us
            </span>
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Your Trusted Partner in{' '}
              <span className="text-amber-500">Global Logistics</span>
            </h2>
            <p className="text-lg text-slate-600 mb-10 leading-relaxed">
              With decades of combined experience, our team delivers exceptional
              freight solutions that keep your supply chain moving efficiently
              across borders and continents.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-6">
              {whyChooseUs.map((item, index) => {
                const Icon = iconMap[item.icon];
                return (
                  <Card
                    key={index}
                    className="bg-white border-0 shadow-md hover:shadow-lg transition-all duration-300 group"
                  >
                    <CardContent className="p-6">
                      <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-amber-500 transition-colors duration-300">
                        {Icon && <Icon className="w-6 h-6 text-amber-600 group-hover:text-white transition-colors duration-300" />}
                      </div>
                      <h3 className="font-bold text-slate-900 mb-2">
                        {item.title}
                      </h3>
                      <p className="text-sm text-slate-600">
                        {item.description}
                      </p>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
